import React from "react";
import "./Button.css";

function Button({ handleClick, content }) {
  return (
    <div className = "button_contain">
      <button className="button" type="button" onClick={handleClick}>
        {content}
      </button>
    </div>
  );
}

export default Button;
